<template>
    <div class="popup">
        <div class="popup-content" :class="{ 'is-loading': isLoading }">
            <button class="popup-close" @click.prevent="handleClosePopup"></button>

            <div class="popup-scrollable">
                <h2>Rapport genereren</h2>

                <div class="alert alert-info mb-5">
                    <strong>Let op:</strong> Het rapport wordt in de achtergrond gegenereerd. Het kan even duren voor het rapport beschikbaar is.
                </div>

                <form method="post" @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)" style="margin-top: 10px;">

                    <div class="alert alert-danger" v-if="error" v-text="error"></div>
                    <div class="alert alert-success" v-if="success" v-text="success"></div>

                    <div class="form-group form-group--small" :class="{ 'is-invalid': form.errors.has('reference') }">
                        <label class="form-label" for="reference">Referentie</label>
                        <input type="text" class="form-control" name="reference" id="reference" v-model="form.reference">
                    </div>

                    <input type="submit" value="Rapport genereren" class="btn btn-primary mt-2">
                </form>
            </div>
        </div>
    </div>
</template>

<script>
	import Form from '@/utilities/Form'
	import { GENERATE_REPORT } from '../../store/modules/projects'

	export default {
		components: {},

		props: ['project'],

		data () {
			return {
				error: null,
				success: null,
				isLoading: false,
				form: new Form({
					reference: null,
				}),
			}
		},

		mounted () {
			if (this.project.reports) {
				this.form.reference = this.project.file_id + '-' + this.pad(this.project.reports.length + 1, 2)
			} else {
				this.form.reference =  this.project.file_id + '-01'
			}
		},

		methods: {
			pad (n, width, z) {
				z = z || '0'
				n = n + ''
				return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
			},

			handleClosePopup () {
				this.$emit('togglePopup')
			},

			onSubmit () {
				this.isLoading = true

				this.$store.dispatch(GENERATE_REPORT, {
					project: this.project.id,
					reference: this.form.reference.toUpperCase(),
				}).then(() => {
					this.isLoading = false
					this.$emit('togglePopup')
				})
			},
		},
	}
</script>
